/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useCallback, useEffect, useState } from 'react';
import { FiFrown, FiEye, FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';

import Select from 'react-select';
import { generateId } from '../../utils/generateId';
import {
  getAllNoticies,
  getAllTemplates,
  getSellersSearch,
  createNotification,
  deleteNotification,
  updateNotification,
} from '../../services/api';

import {
  AlertWrapper,
  Container,
  Tabs,
  Tab,
  Modal,
  ModalContent,
  ButtonGroup,
  ActionButton,
} from './styles';
import { TemplatesList } from './Templates/TemplatesList';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

interface ISeller {
  id: string;
  name: string;
}

interface ITarget {
  id: string;
  seller: ISeller;
}

interface ITemplate {
  id: string;
  title: string;
  htmlContent: string;
  requiresReadConfirmation: boolean;
  createdAt: string;
  updatedAt: string;
}

interface INotification {
  id: string;
  templateId: string;
  template: ITemplate;
  targetType: 'SELECTED' | 'ALL';
  targets: ITarget[];
  createdAt: string;
  updatedAt: string;
}

const Notifications: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();

  const [dataSource, setDataSource] = useState<INotification[]>([]);

  const [activeTab, setActiveTab] = useState<'notifications' | 'template'>(
    'notifications',
  );

  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [templatesOptions, setTemplatesOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [sellersOptions, setSellersOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [notificationForm, setNotificationForm] = useState<{
    templateId: string;
    targetType: 'ALL' | 'SELECTED';
    selectedSellerIds: string[];
  }>({
    templateId: '',
    targetType: 'ALL',
    selectedSellerIds: [],
  });
  const [saving, setSaving] = useState(false);
  const [selectedNotification, setSelectedNotification] =
    useState<INotification | null>(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingNotificationId, setEditingNotificationId] = useState<
    string | null
  >(null);

  const getData = useCallback(async () => {
    try {
      const { data: allNoticies } = await getAllNoticies();

      //   [
      //     {
      //         "id": "d8885f81-6dd4-435f-9986-e0193265a6f1",
      //         "templateId": "4c7cc5fd-098e-4ed1-9759-dc9596de868a",
      //         "template": {
      //             "id": "4c7cc5fd-098e-4ed1-9759-dc9596de868a",
      //             "title": "test",
      //             "htmlContent": "<div> teste1 </>",
      //             "requiresReadConfirmation": false,
      //             "createdAt": "2025-04-05T15:16:10.931Z",
      //             "updatedAt": "2025-04-05T15:16:10.931Z"
      //         },
      //         "targetType": "SELECTED",
      //         "targets": [
      //             {
      //                 "id": "f826caf5-fb77-4401-8845-60fd762249b7",
      //                 "seller": {
      //                     "id": "2572f5a8-ed29-4ba9-8ef5-3d4a405b15d5",
      //                     "name": "Faculdade de Iporá"
      //                 }
      //             }
      //         ],
      //         "createdAt": "2025-04-05T15:46:09.580Z",
      //         "updatedAt": "2025-04-05T15:46:09.580Z"
      //     }
      // ]

      console.log('data', allNoticies);

      setDataSource(allNoticies);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Atenção!',
        description:
          'Não foi possível realizar esta operação, tente novamente.',
      });
    }
  }, [addToast]);

  const initialize = useCallback(async () => {
    getData();
  }, [getData]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if (isNotificationModalOpen) {
      getAllTemplates().then(({ data }) => {
        setTemplatesOptions(
          data.map(t => {
            console.log('Template object:', t);
            return { value: t.id, label: t.title };
          }),
        );
      });
      getSellersSearch({ status: 'active', order: 'ASC' }).then(({ data }) => {
        console.log('Sellers data:', data);
        setSellersOptions(
          data.map(s => ({ value: s.seller.id, label: s.seller.name })),
        );
      });
    }
  }, [isNotificationModalOpen]);

  const handleNotificationChange = e => {
    const { name, value } = e.target;
    setNotificationForm(prev => ({ ...prev, [name]: value }));
  };

  const handleTemplateSelect = option => {
    setNotificationForm(prev => ({ ...prev, templateId: option?.value || '' }));
  };

  const handleTargetTypeChange = e => {
    e.persist();
    console.log('--------------------------------------------------------');
    console.log(e.target.value);
    console.log('--------------------------------------------------------');
    setNotificationForm(prev => ({
      ...prev,
      targetType: e.target.value,
      selectedSellerIds: [],
    }));
  };

  const handleSellersSelect = options => {
    setNotificationForm(prev => ({
      ...prev,
      selectedSellerIds: options ? options.map(o => o.value) : [],
    }));
  };

  const handleSaveNotification = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editingNotificationId) {
        await updateNotification(editingNotificationId, notificationForm);
        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Notificação atualizada com sucesso.',
        });
        setIsEditModalOpen(false);
      } else {
        await createNotification(notificationForm);
        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Notificação criada com sucesso.',
        });
        setIsNotificationModalOpen(false);
      }
      setNotificationForm({
        templateId: '',
        targetType: 'ALL',
        selectedSellerIds: [],
      });
      setEditingNotificationId(null);
      getData();
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro!',
        description: 'Não foi possível salvar a notificação, tente novamente.',
      });
    } finally {
      setSaving(false);
    }
  };

  const handleViewNotification = (notification: INotification) => {
    setSelectedNotification(notification);
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedNotification(null);
  };

  const handleEditNotification = (notification: INotification) => {
    setEditingNotificationId(notification.id);
    setNotificationForm({
      templateId: notification.templateId,
      targetType: notification.targetType,
      selectedSellerIds: notification.targets.map(target => target.seller.id),
    });
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditingNotificationId(null);
    setNotificationForm({
      templateId: '',
      targetType: 'ALL',
      selectedSellerIds: [],
    });
  };

  const handleDeleteNotification = async (id: string) => {
    if (window.confirm('Tem certeza que deseja excluir esta notificação?')) {
      try {
        setLoading(true);
        await deleteNotification(id);
        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Notificação excluída com sucesso.',
        });
        getData();
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro!',
          description:
            'Não foi possível excluir a notificação, tente novamente.',
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleKeyPress = (
    e: React.KeyboardEvent,
    notification: INotification,
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleViewNotification(notification);
    }
  };

  return (
    <Container>
      <header>
        <h1>Relatório de Notificação</h1>
        <span>{user.name}</span>
      </header>

      <Tabs>
        <Tab
          onClick={() => setActiveTab('notifications')}
          active={activeTab === 'notifications'}
        >
          Notificações
        </Tab>
        <Tab
          onClick={() => setActiveTab('template')}
          active={activeTab === 'template'}
        >
          Templates
        </Tab>
      </Tabs>

      {activeTab === 'notifications' ? (
        <>
          <ButtonGroup>
            <ActionButton onClick={() => setIsNotificationModalOpen(true)}>
              <FiPlus size={20} />
              Nova Notificação
            </ActionButton>
          </ButtonGroup>
          <table>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Template</th>
                <th>Tipo</th>
                <th>Data de Criação</th>
                <th>Última Atualização</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {dataSource.map(notification => (
                <tr
                  key={notification.id}
                  onClick={() => handleViewNotification(notification)}
                  onKeyPress={e => handleKeyPress(e, notification)}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <td>
                    {notification.targets
                      .map(target => target.seller.name)
                      .join(', ')}
                  </td>
                  <td>{notification.template.title}</td>
                  <td>
                    {notification.targetType === 'SELECTED'
                      ? 'Selecionados'
                      : 'Todos'}
                  </td>
                  <td>
                    {new Date(notification.createdAt).toLocaleDateString(
                      'pt-BR',
                    )}
                  </td>
                  <td>
                    {new Date(notification.updatedAt).toLocaleDateString(
                      'pt-BR',
                    )}
                  </td>
                  <td>
                    <ButtonGroup>
                      <ActionButton
                        onClick={e => {
                          e.stopPropagation();
                          handleEditNotification(notification);
                        }}
                      >
                        <FiEdit2 size={20} />
                        Editar
                      </ActionButton>
                      <ActionButton
                        onClick={e => {
                          e.stopPropagation();
                          handleDeleteNotification(notification.id);
                        }}
                      >
                        <FiTrash2 size={20} />
                        Excluir
                      </ActionButton>
                    </ButtonGroup>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {dataSource.length === 0 && (
            <AlertWrapper>
              <FiFrown size={50} />
              Sem dados para apresentação
            </AlertWrapper>
          )}

          {isViewModalOpen && selectedNotification && (
            <Modal>
              <ModalContent>
                <header>
                  <h2>{selectedNotification.template.title}</h2>
                  <button type="button" onClick={handleCloseViewModal}>
                    ×
                  </button>
                </header>
                <div>
                  <p>
                    <strong>Template:</strong>{' '}
                    {selectedNotification.template.title}
                  </p>
                  <p>
                    <strong>Tipo:</strong>{' '}
                    {selectedNotification.targetType === 'SELECTED'
                      ? 'Selecionados'
                      : 'Todos'}
                  </p>
                  <p>
                    <strong>Clientes:</strong>{' '}
                    {selectedNotification.targets
                      .map(target => target.seller.name)
                      .join(', ')}
                  </p>
                  <p>
                    <strong>Data de Criação:</strong>{' '}
                    {new Date(
                      selectedNotification.createdAt,
                    ).toLocaleDateString('pt-BR')}
                  </p>
                  <p>
                    <strong>Última Atualização:</strong>{' '}
                    {new Date(
                      selectedNotification.updatedAt,
                    ).toLocaleDateString('pt-BR')}
                  </p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedNotification.template.htmlContent,
                    }}
                  />
                </div>
              </ModalContent>
            </Modal>
          )}

          {isEditModalOpen && (
            <Modal>
              <ModalContent>
                <header>
                  <h2>Editar Notificação</h2>
                  <button type="button" onClick={handleCloseEditModal}>
                    ×
                  </button>
                </header>
                <form onSubmit={handleSaveNotification}>
                  <div style={{ marginBottom: 16 }}>
                    <label>Template</label>
                    <Select
                      options={templatesOptions}
                      value={
                        templatesOptions.find(
                          o => o.value === notificationForm.templateId,
                        ) || null
                      }
                      onChange={handleTemplateSelect}
                      placeholder="Selecione o template"
                      isClearable
                    />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label>Tipo de Destino</label>
                    <div style={{ display: 'flex', gap: 16 }}>
                      <label>
                        <input
                          type="radio"
                          name="targetType"
                          value="ALL"
                          checked={notificationForm.targetType === 'ALL'}
                          onChange={handleTargetTypeChange}
                        />
                        Todos
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="targetType"
                          value="SELECTED"
                          checked={notificationForm.targetType === 'SELECTED'}
                          onChange={handleTargetTypeChange}
                        />
                        Selecionar Clientes
                      </label>
                    </div>
                  </div>
                  {notificationForm.targetType === 'SELECTED' ? (
                    <div style={{ marginBottom: 16 }}>
                      <label>Clientes</label>
                      <Select
                        options={sellersOptions}
                        value={sellersOptions.filter(o =>
                          notificationForm.selectedSellerIds.includes(o.value),
                        )}
                        onChange={handleSellersSelect}
                        isMulti
                        placeholder="Selecione os clientes"
                      />
                    </div>
                  ) : null}
                  <ButtonGroup>
                    <ActionButton type="submit" disabled={saving}>
                      {saving ? 'Salvando...' : 'Salvar'}
                    </ActionButton>
                    <ActionButton type="button" onClick={handleCloseEditModal}>
                      Cancelar
                    </ActionButton>
                  </ButtonGroup>
                </form>
              </ModalContent>
            </Modal>
          )}
        </>
      ) : (
        <TemplatesList />
      )}

      {isNotificationModalOpen && (
        <Modal>
          <ModalContent>
            <h2 style={{ marginBottom: 30 }}>Criar Notificação</h2>
            <form onSubmit={handleSaveNotification}>
              <div style={{ marginBottom: 30 }}>
                <label>Template</label>
                <Select
                  options={templatesOptions}
                  value={
                    templatesOptions.find(
                      o => o.value === notificationForm.templateId,
                    ) || null
                  }
                  onChange={handleTemplateSelect}
                  placeholder="Selecione o template"
                  isClearable
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Tipo de Destino</label>
                <div style={{ display: 'flex', gap: 16 }}>
                  <label>
                    <input
                      type="radio"
                      name="targetType"
                      value="ALL"
                      checked={notificationForm.targetType === 'ALL'}
                      onChange={handleTargetTypeChange}
                    />
                    Todos
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="targetType"
                      value="SELECTED"
                      checked={notificationForm.targetType === 'SELECTED'}
                      onChange={handleTargetTypeChange}
                    />
                    Selecionar Clientes
                  </label>
                </div>
              </div>
              {notificationForm.targetType === 'SELECTED' ? (
                <div style={{ marginBottom: 16 }}>
                  <label>Clientes</label>
                  <Select
                    options={sellersOptions}
                    value={sellersOptions.filter(o =>
                      notificationForm.selectedSellerIds.includes(o.value),
                    )}
                    onChange={handleSellersSelect}
                    isMulti
                    placeholder="Selecione os clientes"
                  />
                </div>
              ) : null}
              <ButtonGroup>
                <ActionButton type="submit" disabled={saving}>
                  {saving ? 'Salvando...' : 'Salvar'}
                </ActionButton>
                <ActionButton
                  type="button"
                  onClick={() => setIsNotificationModalOpen(false)}
                >
                  Cancelar
                </ActionButton>
              </ButtonGroup>
            </form>
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export { Notifications };
